import React, { useState } from 'react';

import { Card } from 'antd';

import styled from 'styled-components';

import { showLog } from '@libs/NwMoment';

import { usePlaylistPackages, usePlaylistLastPackages } from '@hooks/API/UsePlaylist';

import ContactAvatarGroup from '@components/ContactAvatarGroup/ContactAvatarGroup';
import CreatedBy from '@components/CreatedBy/CreatedBy';
import EmptyState from '@components/Gui/EmptyState';
import { Loading } from '@components/Gui/Loading';
import { NwButton } from '@components/Gui/NwButton';
import { NwCard } from '@components/Gui/NwCard/NwCard';
import NwDrawer from '@components/Gui/NwDrawer';
import NwIcon from '@components/Gui/NwIcon';
import PackageDrawer from '@components/PackageDrawer/PackageDrawer';
import ProjectLine from '@components/ProjectLine/ProjectLine';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Container = styled.div`
    .ant-card-body-content {
        padding: 0 !important;
    }

    .ant-card-grid {
        float: left; //added because ant removed it to use flex- to update later
        min-height: 14rem;
        padding: 0;
        width: 100%;
        position: relative;

        .package-container {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin: 1rem 1.5rem;
            cursor: pointer;

            .package-content {
                padding-top: 0.5rem;
                h2 {
                    font-size: 1rem;
                    font-weight: 600;
                    text-transform: uppercase;
                    margin: 0;
                }
                p,
                div {
                    margin: 0;
                    font-size: 0.85rem;
                    line-height: 1.2em;
                }
                .package-projectline-container {
                }
            }
            .package-content-bottom {
                opacity: 0.75;
                font-size: 0.8rem;
                position: absolute;
                bottom: 0.5rem;
                right: 0.5rem;
                text-align: right;
                em {
                    font-style: normal !important;
                }
            }
        }
    }

    .nw-card-paginated-content {
        padding: 0 !important;
    }
    .ant-row-space-between {
        flex-direction: row-reverse;
    }
`;

const IconTextContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0.25rem 0 !important;
    svg {
        min-width: 2rem;
    }
`;

const MediaFullPackages = ({ playlistID }) => {
    const { data: packages, isFetching } = usePlaylistPackages(playlistID);
    const [packageID, setPackageID] = useState();
    const [showPackageDrawer, setShowPackageDrawer] = useState(false);

    const getModelIDs = (pack) => {
        const models = pack.Models.map((m) => m.ModelID);
        return models;
    };

    const handleOpenLatestPackage = (packageItem) => () => {
        setPackageID(packageItem.ID);
        setShowPackageDrawer(true);
    };

    const handleClosePackageDrawer = () => {
        setShowPackageDrawer(false);
        setPackageID();
    };

    const renderPackages = (packages) => {
        return (
            <>
                {packages.map((pack) => (
                    <Card.Grid key={`packcard-${pack.ID}`}>
                        <div
                            className="package-container"
                            onClick={handleOpenLatestPackage(pack)} /*key={`pack-${pack.ID}`}*/
                        >
                            <ContactAvatarGroup contactIDs={getModelIDs(pack)} />
                            <div className="package-content">
                                {pack.Project && (
                                    <div className="package-projectline-container">
                                        <ProjectLine project={pack.Project} ellipsis />
                                    </div>
                                )}
                                <h2>{pack.Name}</h2>
                                <IconTextContainer>
                                    <NwIcon icon={byPrefixAndName.fasl['envelopes']} />
                                    <p>
                                        sent to:{' '}
                                        {pack.Recipients.length > 0
                                            ? pack.Recipients.length > 5
                                                ? `${pack.Recipients.length} recipients`
                                                : pack.Recipients.map((recipient) => recipient.Email).join(', ')
                                            : 'no recipient'}
                                    </p>
                                </IconTextContainer>
                                {pack.LastSentDate ? (
                                    <IconTextContainer>
                                        <NwIcon icon={byPrefixAndName.fasl['paper-plane']} />
                                        <p>sent on: {showLog(pack.LastSentDate)}</p>
                                    </IconTextContainer>
                                ) : (
                                    <IconTextContainer>
                                        <NwIcon icon={byPrefixAndName.fasl['hourglass']} />
                                        <p>not sent</p>
                                    </IconTextContainer>
                                )}
                            </div>
                            <div className="package-content-bottom">
                                <CreatedBy object={pack} />
                            </div>
                        </div>
                    </Card.Grid>
                ))}
            </>
        );
    };

    return (
        <Container>
            {isFetching ? <Loading textBlack /> : renderPackages(packages)}
            {showPackageDrawer && <PackageDrawer packageId={packageID} onClose={handleClosePackageDrawer} />}
        </Container>
    );
};

const MediaPackages = ({ playlistID }) => {
    const { data: packages, isFetching } = usePlaylistLastPackages(playlistID);
    const [showPackageDrawer, setShowPackageDrawer] = useState(false);
    const [packageID, setPackageID] = useState();
    const [showAll, setShowAll] = useState(false);

    const handleOpenLatestPackage = (packageItem) => () => {
        setPackageID(packageItem.ID);
        setShowPackageDrawer(true);
    };

    const handleClosePackageDrawer = () => {
        setShowPackageDrawer(false);
        setPackageID();
    };

    const getModelIDs = (pack) => {
        const models = pack.Models.map((m) => m.ModelID);
        return models;
    };

    const renderPackages = (packages) => {
        return (
            <>
                {packages.map((pack) => (
                    <Card.Grid key={`packcard-${pack.ID}`}>
                        <div
                            className="package-container"
                            onClick={handleOpenLatestPackage(pack)} /*key={`pack-${pack.ID}`}*/
                        >
                            <ContactAvatarGroup contactIDs={getModelIDs(pack)} />
                            <div className="package-content">
                                {pack.Project && (
                                    <div className="package-projectline-container">
                                        <ProjectLine project={pack.Project} ellipsis />
                                    </div>
                                )}
                                <h2>{pack.Name}</h2>
                                <IconTextContainer>
                                    <NwIcon icon={byPrefixAndName.fasl['envelopes']} />
                                    <p>
                                        sent to:{' '}
                                        {pack.Recipients.length > 0
                                            ? pack.Recipients.length > 5
                                                ? `${pack.Recipients.length} recipients`
                                                : pack.Recipients.map((recipient) => recipient.Email).join(', ')
                                            : 'no recipient'}
                                    </p>
                                </IconTextContainer>
                                {pack.LastSentDate ? (
                                    <IconTextContainer>
                                        <NwIcon icon={byPrefixAndName.fasl['paper-plane']} />
                                        <p>sent on: {showLog(pack.LastSentDate)}</p>
                                    </IconTextContainer>
                                ) : (
                                    <IconTextContainer>
                                        <NwIcon icon={byPrefixAndName.fasl['hourglass']} />
                                        <p>not sent</p>
                                    </IconTextContainer>
                                )}
                            </div>
                            <div className="package-content-bottom">
                                <CreatedBy object={pack} />
                            </div>
                        </div>
                    </Card.Grid>
                ))}
            </>
        );
    };

    return (
        <Container>
            <NwCard
                icon={byPrefixAndName.fasl['book-arrow-right']}
                title={packages && packages.length > 5 ? 'Last 5 packages' : 'Packages'}
                extra={
                    packages && packages.length > 5 ? (
                        <NwButton size="small" primary ghost onClick={() => setShowAll(true)} label="Show All" />
                    ) : null
                }
            >
                {isFetching ? (
                    <Loading textBlack />
                ) : packages && packages.length ? (
                    renderPackages(packages.slice(0, 5))
                ) : (
                    <EmptyState message="No packages" />
                )}
                {showPackageDrawer && <PackageDrawer packageId={packageID} onClose={handleClosePackageDrawer} />}
                {showAll && (
                    <NwDrawer title="Packages" onClose={() => setShowAll(false)}>
                        <MediaFullPackages playlistID={playlistID} />
                    </NwDrawer>
                )}
            </NwCard>
        </Container>
    );
};

export default MediaPackages;
